import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router';
import { loginRedirect } from './AuthApi/authApi';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { ErrorCodes } from 'src/common/responseCodes';
import NotFoundImage from 'assets/images/notFound.png';
import CommonErrorImage from 'assets/images/commonErrorBG.svg';

export const RouteErrorBoundary = () => {
  const { t } = useTranslation();
  const routeError = useRouteError() as Error;

  useEffect(() => {
    if (routeError.message === ErrorCodes.AccessDenied) {
      loginRedirect();
    }
  }, [routeError]);

  if (routeError.message === ErrorCodes.AccessDenied) {
    return null;
  }

  return (
    <Box
      component="main"
      sx={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
      role="alert"
    >
      {routeError.message === ErrorCodes.NotFound ? (
        <>
          <img src={NotFoundImage} alt="" />
          <Typography
            variant="h1"
            sx={{
              mt: 20,
            }}
          >
            {t('common.pageNotFound')}
          </Typography>
          <Button
            href="/"
            sx={{
              mt: 12,
            }}
          >
            {t('common.backToDashboard')}
          </Button>
        </>
      ) : (
        <>
          <CommonErrorImage />
          <Typography variant="h1">{t('auth.somethingWrong')}</Typography>
        </>
      )}
    </Box>
  );
};
